import React from "react";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import useSeller from "./useSeller";
import axios from "axios";
import {useNavigate} from "react-router-dom";

export default function () {
  const {handleSubmit, setErrors, sellerFields} = useSeller();
  const navigate = useNavigate();

  const addSeller = data => {
    axios.post('sellers', data, {
      headers: {
        'Password-reset': true,
      },
    }).then(res => {
      navigate('/sellers');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data?.errors || {});
      }
    });
  }

  return (
    <Card title="Add seller">
      <form className="form w-100" onSubmit={handleSubmit(addSeller)}>
        {sellerFields}

        <SubmitButton title="Add" classes='mt-5'/>
      </form>
    </Card>
  );
}